import '@forest/shared/polyfills'

import './setup'

import { QueryClientProvider } from '@tanstack/react-query'
import { lazy, StrictMode, Suspense, useEffect } from 'react'
import { createRoot } from 'react-dom/client'
import '~/styles/global.css'
import { DevTools } from './components/dev-tools'
import { loadContentWithRecovery } from './lib/content'
import { queryClient } from './lib/query-client'
import { native } from '@forest/native-services'
import { saveTurn } from './turns'

const shouldRenderDevTools = import.meta.env.MODE !== 'production'

// The selected feature's content load, retried inside the presentation's
// original loading budget. A repeatable content or asset failure recovers here
// without replacing the document, so the reveal condition below is unchanged:
// the fallback still unmounts only when the real content has loaded.
const Page = lazy(loadContentWithRecovery)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<Fallback />}>
        <Page />
      </Suspense>
      {shouldRenderDevTools && <DevTools />}
    </QueryClientProvider>
  </StrictMode>,
)

function Fallback() {
  useEffect(() => {
    return () => {
      native.general.pageReady()
    }
  }, [])
  return <></>
}

saveTurn()
